import { render, staticRenderFns } from "./CopyStakeStreamersStats.vue?vue&type=template&id=b64a0c2a&lang=pug"
import script from "./CopyStakeStreamersStats.vue?vue&type=script&lang=ts"
export * from "./CopyStakeStreamersStats.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports